module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/icon-situation-a12fe2e91dc1637ffbd19f84fa54b394.webp";